import { StyleSheet, View, Image, TextInput, TouchableWithoutFeedback, ActivityIndicator, Text, Pressable, ScrollView } from 'react-native';
import { useState, useEffect, useRef } from 'react';
import { doc, collection, setDoc, addDoc, Timestamp, getDoc, updateDoc, query, where, getDocs } from "firebase/firestore"; 
import * as ImagePicker from 'expo-image-picker';
import Ionicons from '@expo/vector-icons/Ionicons';
import FontAwesome from '@expo/vector-icons/FontAwesome';
import { Menu, MenuOptions, MenuOption, MenuTrigger } from 'react-native-popup-menu';
import { GooglePlacesAutocomplete } from 'react-native-google-places-autocomplete';
import { db } from '../../firebaseConfig';
import Button from '../shared/Button';
import AddPhoneNumber from './AddPhoneNumber';
import AddEmail from './AddEmail';
import InstallPrompt from './InstallPrompt';
import ImageViewer from '../ImageViewer';
const PlaceholderImage = require('../../assets/images/select-image.png');
import { saveImage }  from '../../services/storage/Storage';
import { enableNotifications } from '../../services/notifications/Notifications';
import { isInstalledPwa, canPromptInstall, promptInstall, subscribeToInstallState } from '../../services/utils/General';
import { getUserDataByUserId, sendOneTimeLoginCode, sendOneTimeLoginCodeByEmail, getUserIdByEmail, verifyCodeByTwilio, getUserIdByPhone, getBarNamesByBusinessIds }  from '../../services/users/Users';

export default function CreateAccountScreen({ route, navigation }) {

  const location = route && route.params ? route.params.location : null;

  const [emailOrPhone, setEmailOrPhone] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [userEnteredCode, setUserEnteredCode] = useState('');
  const [verificationResultMessage, setVerificationResultMessage] = useState('');

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(false);
  const [animating, setAnimating] = useState(false);
  const [saveResultMessage, setSaveResultMessage] = useState('');
  const [sentEmailConfirmMessage, setSentEmailConfirmMessage] = useState('');
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [favoriteBar, setFavoriteBar] = useState('');
  // Google place_id uniquely identifies the favorite bar; empty when the user typed free text without choosing a suggestion
  const [favoriteBarPlaceId, setFavoriteBarPlaceId] = useState('');
  const [loadedFavoriteBar, setLoadedFavoriteBar] = useState('');
  const refFavoriteBar = useRef(null);

  // favorite bar (which implies notifications) is only offered once the app is installed
  const [isInstalled] = useState(isInstalledPwa());
  const [canInstall, setCanInstall] = useState(canPromptInstall());
  const [installMessage, setInstallMessage] = useState('');

  useEffect(() => subscribeToInstallState(() => setCanInstall(canPromptInstall())), []);

  const handleInstall = async () => {
    const outcome = await promptInstall();
    if (outcome === 'accepted') {
      setInstallMessage('Installed! Open BarSwim from your home screen or app list to choose your favorite bar.');
    }
  };
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [isVerifyingCode, setIsVerifyingCode] = useState(false);

  const [isBusinessRepresentative, setIsBusinessRepresentative] = useState(false);
  const [businessName, setBusinessName] = useState('');

  // Phone number addition state
  const [showAddPhone, setShowAddPhone] = useState(false);

  // Email addition state
  const [showAddEmail, setShowAddEmail] = useState(false);

  // use this to determine if we should show Save or Continue
  const [isDirty, setIsDirty] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [isNewImage, setIsNewImage] = useState(false);
  const [approvedBusinesses, setApprovedBusinesses] = useState([]);
  const [pendingBusinesses, setPendingBusinesses] = useState([]);

  useEffect(() => {
    (async () => {

      // console.log('here in useEffect. localstorage user id:', window.localStorage.getItem('userId'));
      let savedUserId = window.localStorage.getItem('userId');
      if (savedUserId) {
        // navigation.setOptions({ title: 'Edit Profile' });
        setIsSignedIn(true);

        // set is Dirty so it's not confusing to the user they can "Save"
        setIsDirty(true);

        // // TODO move this into its own function, used in multiple places
        // // use the Users service to get the user data
        // const userRef = doc(db, "Users", savedUserId);
        // const userSnap = await getDoc(userRef);
        // if (userSnap.data().username) {
        //   setUsername(userSnap.data().username);
        // }
        // if (userSnap.data().email) {
        //   setEmail(userSnap.data().email);
        // }
        // if (userSnap.data().isEmailConfirmed) {
        //   setIsEmailConfirmed(userSnap.data().isEmailConfirmed);
        // }
        // if (userSnap.data().storageImageUrl) {
        //   setSelectedImage(userSnap.data().storageImageUrl);
        // }
        // if (userSnap.data().favoriteBar) {
        //   setFavoriteBar(userSnap.data().favoriteBar);
        // }

        await loadUserInformation(savedUserId);
      }
      else {
        navigation.setOptions({ title: 'Sign in or Create an account' });
      }

      // // new user
      // console.log('route.params', route.params);
      // if (route != null && route.params != null && route.params.email) {
      //   setEmail(route.params.email);
      //   setIsNewUser(true);
      //   navigation.setOptions({ title: 'Edit Profile' });        
      // }      

    })();
  }, [])

  // the autocomplete only mounts once signed in, so populate its text after it renders
  useEffect(() => {
    if (isSignedIn && !isNewUser && refFavoriteBar.current && loadedFavoriteBar) {
      refFavoriteBar.current.setAddressText(loadedFavoriteBar);
    }
  }, [isSignedIn, isNewUser, loadedFavoriteBar]);

  const loadUserInformation = async (userId) => {
    const userData = await getUserDataByUserId(userId);
    if (userData.username) {
      setUsername(userData.username);
      window.localStorage.setItem('username', userData.username);
    }
    if (userData.email) {
      setEmail(userData.email);
    }
    if (userData.isEmailConfirmed) {
      setIsEmailConfirmed(userData.isEmailConfirmed);
    }
    if (userData.storageImageUrl) {
      setSelectedImage(userData.storageImageUrl);
    }
    if (userData.favoriteBar) {
      setFavoriteBar(userData.favoriteBar);
      setLoadedFavoriteBar(userData.favoriteBar);
    }
    if (userData.favoriteBarPlaceId) {
      setFavoriteBarPlaceId(userData.favoriteBarPlaceId);
    }
    if (userData.phone) {
      setPhoneNumber(userData.phone);
    }
    // if (userData.isBusinessRep) {
    //   setIsBusinessRepresentative(userData.isBusinessRep);
    // }
    // if (userData.businessName) {
    //   setBusinessName(userData.businessName);
    // }
    if (userData.businessIds && userData.businessIds.length > 0) {
       setIsBusinessRepresentative(true);

       const businessNames = await getBarNamesByBusinessIds(userData.businessIds);
        if (businessNames && businessNames.length > 0) {
          setApprovedBusinesses(businessNames);
        }
    }
    if (userData.pendingBusinessIds && userData.pendingBusinessIds.length > 0) {
       setIsBusinessRepresentative(true);

       const businessNames = await getBarNamesByBusinessIds(userData.pendingBusinessIds);
        if (businessNames && businessNames.length > 0) {
          setPendingBusinesses(businessNames);
        }
    }

    if (userData.role === 'admin') {
      navigation.setOptions({
        headerRight: () => (
          <Menu>
            <MenuTrigger>
              <FontAwesome name="ellipsis-v" size={22} color="#674FE0" style={styles.headerMenuIcon} />
            </MenuTrigger>
            <MenuOptions>
              <MenuOption onSelect={() => navigation.navigate('ApprovalsScreen')} text='Approvals' />
            </MenuOptions>
          </Menu>
        ),
      });
    }

    navigation.setOptions({ title: 'Your Profile' });
  }

  const sendSignInCode = async (e) => {
    e.preventDefault();

    // Disable the button to prevent multiple clicks
    setIsSendingCode(true);

    // determine if phone or email
    var phone = null;
    var email = null;

    // Simple validation to determine if input is email or phone number
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/; // Simple phone number pattern (allows + prefix, 1-16 digits)

    if (emailRegex.test(emailOrPhone.trim())) {
      email = emailOrPhone.trim();
    } else if (phoneRegex.test(emailOrPhone.trim().replace(/[\s\-\(\)]/g, ''))) {
      // Remove common phone number formatting characters before testing
      phone = emailOrPhone.trim().replace(/[\s\-\(\)]/g, '');
    } else {
      setSentEmailConfirmMessage('Please enter a valid email address or phone number.');
      setIsSendingCode(false);
      return;
    }

    if (email) {
      setEmail(email);
      // generate a 4 digit code
      const code = Math.floor(1000 + Math.random() * 9000);
      //console.log('code=' + code);
      window.localStorage.setItem('loginCode', code);
      window.localStorage.setItem('loginEmail', email);
      window.localStorage.setItem('loginType', 'email');
      // TODO: remove hardcoded bypass for testing
      // if (email === "isulder1@yahoo.com") {
      //   console.log('Bypassing email sending for testing');
      // } else {
        sendOneTimeLoginCodeByEmail(email, code);
      // }
      //setSentEmailConfirmMessage('Code sent to your email! Please check your inbox.');
    } else {
      setPhoneNumber(phone);
      sendOneTimeLoginCode(phone);
      //setSentEmailConfirmMessage('Code sent to your phone! Please check your messages.');
      window.localStorage.setItem('loginPhoneNumber', phone);
      window.localStorage.setItem('loginType', 'phone');
    }

    setIsCodeSent(true);
  }

  const handleUserVerifyCodeSubmit = async (e) => {
    e.preventDefault();

    setIsVerifyingCode(true);

    const loginType = window.localStorage.getItem('loginType');

    if (loginType === 'email') {
      var loginCode = window.localStorage.getItem('loginCode');
      if (loginCode != userEnteredCode) {
        setVerificationResultMessage('Invalid code. Please try again.');
        setIsVerifyingCode(false);
        return;
      }
      var userId = await getUserIdByEmail(window.localStorage.getItem('loginEmail'));
      if (userId != null) {
        window.localStorage.setItem('userId', userId);
        // var user = await getUserDataByUserId(userId);
        setIsSignedIn(true);
        setIsNewUser(false);
        //setVerificationResultMessage('Success! You are signed in.');
        setIsCodeSent(false);
        // setEmail(window.localStorage.getItem('loginEmail'));
        await loadUserInformation(userId);
      } else {
        setIsNewUser(true);
        setVerificationResultMessage('Success! Please create a username to finish creating your account.');
        setIsCodeSent(false);
      }
    } else if (loginType === 'phone') {
      //var loginCode = window.localStorage.getItem('loginCode');
      var phone = window.localStorage.getItem('loginPhoneNumber');
      var result = await verifyCodeByTwilio(userEnteredCode, phone);
      // console.log('verifyCodeByTwilio result=', result);
      if (!result.success) {
        setVerificationResultMessage('Invalid code. Please try again.');
        setIsVerifyingCode(false);
        return;
      }
      var userId = await getUserIdByPhone(phone);
      if (userId != null) {
        window.localStorage.setItem('userId', userId);
        // var user = await getUserDataByUserId(userId);
        setIsSignedIn(true);
        setIsNewUser(false);
        setIsCodeSent(false);
        // setEmail(window.localStorage.getItem('loginEmail'));
        await loadUserInformation(userId);
      } else {
        setIsNewUser(true);
        setVerificationResultMessage('Success! Please create a username to finish creating your account.');
        setIsCodeSent(false);        
      }
    }

    setIsVerifyingCode(false);
  }

  const handleUsernameSubmit = async (e) => {
    e.preventDefault();

    // show activity indicator
    setSaveResultMessage('');
    setAnimating(true);

    // start before any other await so the browser still treats this as a user gesture
    const notificationsPromise = isInstalled && favoriteBarPlaceId
      ? enableNotifications(window.localStorage.getItem('userId'))
      : null;

    // check if user name is taken
    async function getUserByUsername() {

      const q = query(collection(db, "Users"), where('userNameLowerCase', "==" , username.toLowerCase()));

      const querySnapshot = await getDocs(q);
      var userIdWithUsername = null;
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        //console.log(doc.id, " => ", doc.data());
        userIdWithUserName = doc.id;
      });
      return userIdWithUsername;

    }
    let usernameTakenByUserId = await getUserByUsername();
    //console.log('usernameTakenByUserId=', usernameTakenByUserId);

    // check if user has a User record
    let savedUserId = window.localStorage.getItem('userId');
    if (usernameTakenByUserId != null && savedUserId && usernameTakenByUserId != savedUserId)
    {
      setSaveResultMessage('Sorry, ' + username + ' is taken.  Please choose another.');
      setAnimating(false);
      // console.log('username is taken', username);
      return;
    }

    var userInfo = window.localStorage.getItem('userId') != null ? await getUserDataByUserId(window.localStorage.getItem('userId')) : null;
    var needToCreateUser = false;
    if (!userInfo || userInfo == null || userInfo == undefined) {
      needToCreateUser = true;
      //alert("user does not exist, need to create one");
    }    

    if (!savedUserId || needToCreateUser)
    {
      var loginEmail = window.localStorage.getItem('loginEmail');
      var loginPhoneNumber = window.localStorage.getItem('loginPhoneNumber');

      // create a User record
      try {
        const docRef = await addDoc(collection(db, 'Users'), {
          username: username,
          usernameLowerCase: username.toLowerCase(),
          created: Timestamp.now(),
          email: loginEmail ? loginEmail : '',
          emailLowerCase: loginEmail ? loginEmail.toLowerCase() : '',
          isEmailConfirmed: loginEmail ? true : false,
          phone: loginPhoneNumber ? loginPhoneNumber : '',
          isPhoneConfirmed: loginPhoneNumber ? true : false,
        });
        //console.log("User written with ID: ", docRef.id);
        window.localStorage.setItem('userId', docRef.id);
        window.localStorage.setItem('username', username);
        setIsNewUser(false);
        setIsSignedIn(true);
      } catch (err) {
        alert(err)
      }
      navigation.setOptions({ title: 'Your Account' });
    }
    else
    {
      // update the User record
      // console.log('update the user');

      try {
        const userRef = doc(db, "Users", savedUserId);

        // update the User
        // TODO: probably shouldn't update if not "dirty"
        await updateDoc(userRef, {
          username: username,
          usernameLowerCase: username.toLowerCase(),
          email: email,
          favoriteBar: favoriteBar,
          favoriteBarPlaceId: favoriteBarPlaceId,
        });
        window.localStorage.setItem('username', username);

        // console.log('User updated');
      } catch (e) {
        alert(err);
        // console.log("Error update the user: ", e);
      }      
    }

    // if(!isEmailConfirmed && email != null && email != '')
    // {
    //   // send email confirmation
    //   sendEmailConfirmation(email);
    //   setSentEmailConfirmMessage('Email sent.  Please check your email to confirm your account.');
    // }

    // update user record with picture.  doing this after record is created or updated.
    if (selectedImage != null && isNewImage)
    {
      // var storageImageRef = "";
      // var storageImageUrl = "";
      var saveImageResult = await saveImage(selectedImage);
      var storageImageRef = saveImageResult.storageImageRef;
      var storageImageUrl = saveImageResult.storageImageUrl;

      try {
        const userRef = doc(db, "Users", savedUserId);

        // update the User image
        await updateDoc(userRef, {
          storageImageRef: storageImageRef,
          storageImageUrl: storageImageUrl,
        });

        // console.log('User image updated');
      } catch (e) {
        alert(err);
        // console.log("Error update the user image: ", e);
      }
    }

    //setSaveResultMessage('Saved! Your user name is ' + username);
    if (notificationsPromise) {
      const notificationResult = await notificationsPromise;
      console.log('enableNotifications result', notificationResult);
      if (!notificationResult.success && notificationResult.reason === 'denied') {
        setSaveResultMessage('Notifications are blocked for BarSwim, so you will not be notified about your favorite bar. Allow them in your device or browser settings.');
      }
    }
    window.localStorage.setItem('username', username);
    setIsDirty(false);

    // hide activity indicator
    setAnimating(false);

    //let savedUsername = window.localStorage.getItem('username');
    //console.log("savedUsername:", savedUsername);

  }

  const pickImageAsync = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      allowsEditing: true,
      quality: 1,
    });

    if (!result.canceled) {
      setSelectedImage(result.assets[0].uri);
      setIsNewImage(true);
      setIsDirty(true);
      //console.log(result.assets[0].uri);
      //let testing64string = result.assets[0].uri;     
    } else {
      alert('You did not select an image.');
    }
  };

  const handleSignOut = () => {
    // Clear all localStorage values
    window.localStorage.removeItem('userId');
    window.localStorage.removeItem('username');
    window.localStorage.removeItem('loginCode');
    window.localStorage.removeItem('loginEmail');
    window.localStorage.removeItem('loginType');
    
    // Reset all state values
    setIsSignedIn(false);
    setIsCodeSent(false);
    setIsNewUser(false);
    setEmailOrPhone('');
    setUsername('');
    setEmail('');
    setPhoneNumber('');
    setIsEmailConfirmed(false);
    setSelectedImage(null);
    setFavoriteBar('');
    setFavoriteBarPlaceId('');
    setLoadedFavoriteBar('');
    setUserEnteredCode('');
    setVerificationResultMessage('');
    setSaveResultMessage('');
    setSentEmailConfirmMessage('');
    setIsDirty(false);
    setIsNewImage(false);
    
    // Reset phone number addition state
    setShowAddPhone(false);
    
    // Reset email addition state
    setShowAddEmail(false);
    
    // Update navigation title
    navigation.setOptions({ title: 'Sign in or Create an account' });
  };

  const handlePhoneAdded = (phoneNumber) => {
    setPhoneNumber(phoneNumber);
    setShowAddPhone(false);
  };

  const handleCancelAddPhone = () => {
    setShowAddPhone(false);
  };

  const handleEmailAdded = (email) => {
    setEmail(email);
    setIsEmailConfirmed(true);
    setShowAddEmail(false);
  };

  const handleCancelAddEmail = () => {
    setShowAddEmail(false);
  };

  return (
    <ScrollView style={styles.scrollView} contentContainerStyle={styles.container} keyboardShouldPersistTaps="handled">

      {!isSignedIn && !isCodeSent && !isNewUser &&
        <View style={styles.formContainer}>
          <Text style={styles.title}>Sign in or Create an account</Text>
  
          <View style={styles.inputCard}>
            <Text style={styles.label}>Enter your phone number or email:</Text>
            <TextInput
              style={styles.input}
              placeholder="Phone number or email"
              placeholderTextColor="#999"
              onChangeText={newText => setEmailOrPhone(newText)}
              defaultValue={emailOrPhone}
              textAlignVertical={"center"}
              maxLength={40}
            />
          </View>

          <Button theme="basic" label={isSendingCode ? "Sending..." : "Send Me A Code"} onPress={sendSignInCode} isDisabled={isSendingCode} />
          {sentEmailConfirmMessage ? (
            <Text style={styles.messageText}>{sentEmailConfirmMessage}</Text>
          ) : null}

          <Text style={styles.disclaimerText}>We never display your email or phone number to others or share it. It is used only for logging in or creating an account.</Text>

        </View>
      }
      {isCodeSent &&
        <View style={styles.formContainer}>
          <Text style={styles.title}>Enter the code sent to your email or phone:</Text>
          <TextInput
              style={styles.input}
              placeholder="Enter the code"
              placeholderTextColor="#999"
              onChangeText={newText => setUserEnteredCode(newText)}
              defaultValue={userEnteredCode}
              textAlignVertical={"center"}
              maxLength={40}
            />
            <Button theme="basic" label={isVerifyingCode ? "Verifying..." : "Verify Code"} onPress={handleUserVerifyCodeSubmit} isDisabled={isVerifyingCode} />
            <ActivityIndicator size="large" color="#674FE0" animating={isVerifyingCode} hidesWhenStopped={true} />
            {verificationResultMessage ? (
              <Text style={styles.messageText}>{verificationResultMessage}</Text>
            ) : null}
        </View>
      }
      {isNewUser &&
        <View style={styles.formContainer}>
          <Text style={styles.title}>Enter a username to finish creating your account</Text>
          <TextInput
              style={styles.input}
              placeholder="Enter your username"
              placeholderTextColor="#999"
              onChangeText={newText => setUsername(newText)}
              defaultValue={username}
              textAlignVertical={"center"}
              maxLength={40}
            />
            <Button theme="basic" label="Create Account" onPress={handleUsernameSubmit} />
            {saveResultMessage ? (
              <Text style={styles.messageText}>{saveResultMessage}</Text>
            ) : null}
        </View>
      }
      {isSignedIn && !isNewUser &&
        <View style={styles.formContainer}>

          <View style={styles.fieldSection}>
            <Text style={styles.fieldLabel}>Username</Text>
            <TextInput
              style={styles.input}
              placeholder="Enter your username"
              placeholderTextColor="#999"
              onChangeText={newText => setUsername(newText)}
              onChange={() => setIsDirty(true)}
              defaultValue={username}
              textAlignVertical={"center"}
              maxLength={40}
            />
            {saveResultMessage ? (
              <Text style={styles.messageText}>{saveResultMessage}</Text>
            ) : null}
          </View>

          <View style={styles.fieldSection}>
            <Text style={styles.fieldLabel}>Profile Picture</Text>
            <TouchableWithoutFeedback onPress={pickImageAsync}>
              <View style={styles.imagePickerContainer}>
                <ImageViewer
                  placeholderImageSource={PlaceholderImage}
                  selectedImage={selectedImage}
                  width={100}
                  height={100}
                  enablePanZoom={false}
                />
              </View>
            </TouchableWithoutFeedback>
          </View>

          {/* <View style={styles.imageContainer}>
            <Text style={{ fontSize: 18 }}>User image</Text>
            <TouchableWithoutFeedback onPress={pickImageAsync}>
              <View style={styles.imageContainer2}>
                <ImageViewer
                  placeholderImageSource={PlaceholderImage}
                  selectedImage={selectedImage}
                  width={100}
                  height={100}
                  enablePanZoom={false}
                />
              </View>
            </TouchableWithoutFeedback>
          </View> */}

          <View style={styles.fieldSection}>
            <Text style={styles.fieldLabel}>Email</Text>
            {email ? (
              <Text style={styles.fieldValue}>{email}</Text>
            ) : showAddEmail ? (
              <AddEmail 
                onEmailAdded={handleEmailAdded}
                onCancel={handleCancelAddEmail}
              />
            ) : (
              <Text 
                style={styles.addLink} 
                onPress={() => setShowAddEmail(true)}
              >
                Add email address
              </Text>
            )}
          </View>

          <View style={styles.fieldSection}>
            <Text style={styles.fieldLabel}>Phone</Text>
            {phoneNumber ? (
              <Text style={styles.fieldValue}>{phoneNumber}</Text>
            ) : showAddPhone ? (
              <AddPhoneNumber 
                onPhoneAdded={handlePhoneAdded}
                onCancel={handleCancelAddPhone}
              />
            ) : (
              <Text 
                style={styles.addLink} 
                onPress={() => setShowAddPhone(true)}
              >
                Add phone number
              </Text>
            )}
          </View>

          <View style={[styles.fieldSection, { zIndex: 10 }]}>
            <Text style={styles.fieldLabel}>Favorite Bar</Text>
            {!isInstalled ? (
              <InstallPrompt canInstall={canInstall} installMessage={installMessage} onInstall={handleInstall} />
            ) : (
            <GooglePlacesAutocomplete
              placeholder='Search for your favorite bar (optional)'
              ref={refFavoriteBar}
              fetchDetails={true}
              keyboardShouldPersistTaps='handled'
              textInputProps={{
                placeholderTextColor: '#999',
                maxLength: 80,
                // typing after a selection invalidates the previously chosen place
                onChangeText: (newText) => {
                  setFavoriteBar(newText);
                  setFavoriteBarPlaceId('');
                  setIsDirty(true);
                },
              }}
              minLength={2}
              onPress={(data, details = null) => {
                const name = (details && details.name) || (data.structured_formatting && data.structured_formatting.main_text) || data.description || '';
                setFavoriteBar(name);
                setFavoriteBarPlaceId(data.place_id || (details && details.place_id) || '');
                refFavoriteBar.current.setAddressText(name);
                setIsDirty(true);
              }}
              query={{
                language: 'en',
                lat: location ? location.coords.latitude : null,
                lng: location ? location.coords.longitude : null,
              }}
              requestUrl={{
                useOnPlatform: 'web',
                url: 'https://us-central1-atabar-d7693.cloudfunctions.net/placesApiSearch',
              }}
              styles={{
                textInput: styles.input,
                container: { flex: 0, width: '100%', zIndex: 1000 },
                listView: styles.placesListView,
              }}
            />
            )}
          </View>

          <View style={styles.divider} />

          <View style={styles.fieldSection}>
            <Pressable
              style={styles.checkboxRow}
              onPress={() => {
                setIsBusinessRepresentative(!isBusinessRepresentative);
                setIsDirty(true);
              }}
            >
              <Ionicons
                name={isBusinessRepresentative ? 'checkbox' : 'square-outline'}
                size={24}
                color="#674FE0"
              />
              <Text style={styles.checkboxLabel}>I represent a bar / business</Text>
            </Pressable>
            {isBusinessRepresentative &&
              <View style={styles.businessInputContainer}>
                {approvedBusinesses.length === 0 && pendingBusinesses.length === 0 ? (
                  <Text style={styles.fieldValue}>No business added yet</Text>
                ) : (
                  <>
                    {approvedBusinesses.map((business) => (
                      <View key={business.id} style={styles.businessRow}>
                        <Text style={styles.fieldValue}>{business.bar} (Approved)</Text>
                        <Text
                          style={styles.addLink}
                          onPress={() => navigation.navigate('ManageBusiness', { businessId: business.id })}
                        >
                          Edit
                        </Text>
                      </View>
                    ))}
                    {pendingBusinesses.map((business) => (
                      <View key={business.id} style={styles.businessRow}>
                        <Text style={styles.fieldValue}>{business.bar} (Pending Approval)</Text>
                        <Text
                          style={styles.addLink}
                          onPress={() => navigation.navigate('ManageBusiness', { businessId: business.id })}
                        >
                          Edit
                        </Text>
                      </View>
                    ))}
                  </>
                )}
                <Text
                  style={styles.addLink}
                  onPress={() => navigation.navigate('ManageBusiness')}
                >
                  Add Another
                </Text>
              </View>
            }
          </View>

          <ActivityIndicator size="large" color="#674FE0" animating={animating} hidesWhenStopped={true} />

          <View style={styles.buttonSection}>
            { isDirty ?
                <Button theme="basic" label="Save" onPress={handleUsernameSubmit} />
                :
                <Button theme="basic" label="Continue" onPress={() => navigation.navigate('HomeScreen')} />
            }
          </View>
          
          <View style={styles.buttonSection}>
            <Button theme="secondary" label="Sign Out" onPress={handleSignOut} />
          </View>
        </View>
      }

      {/* <View style={styles.textContainer}>
        <TextInput
          style={{ height: 40, width: 300, backgroundColor: '#fff' }}
          placeholder="Enter your email"
          onChangeText={newText => setEmail(newText)}
          defaultValue={email}
          textAlignVertical={"center"}
        />
      </View>

      <Button theme="createaccount" label="Send Email" onPress={handleSubmit} /> */}

    </ScrollView>
  );

}

const styles = StyleSheet.create({
    scrollView: {
      flex: 1,
      backgroundColor: '#F2F2F2',
    },
    container: {
      flexGrow: 1,
      backgroundColor: '#F2F2F2',
      alignItems: 'center',
      paddingTop: 18,
      paddingBottom: 30,
      paddingHorizontal: 12,
    },
    formContainer: {
      width: '100%',
      maxWidth: 400,
      alignItems: 'center',
    },
    title: {
      fontSize: 22,
      fontWeight: '600',
      color: '#333',
      marginBottom: 14,
      textAlign: 'center',
    },
    inputCard: {
      backgroundColor: '#fff',
      borderRadius: 12,
      padding: 10,
      marginBottom: 14,
      width: '100%',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 3,
    },
    label: {
      fontSize: 14,
      fontWeight: '500',
      color: '#555',
      marginBottom: 5,
    },
    input: {
      height: 44,
      backgroundColor: '#fff',
      borderWidth: 1,
      borderColor: '#ddd',
      borderRadius: 8,
      paddingHorizontal: 12,
      fontSize: 16,
      color: '#333',
      width: '100%',
      marginBottom: 10,
    },
    fieldSection: {
      width: '100%',
      marginBottom: 14,
    },
    divider: {
      width: '100%',
      height: 1,
      backgroundColor: '#d0d0d0',
      marginTop: 6,
      marginBottom: 20,
    },
    fieldLabel: {
      fontSize: 16,
      fontWeight: '600',
      color: '#333',
      marginBottom: 5,
    },
    fieldValue: {
      fontSize: 16,
      color: '#555',
      paddingVertical: 5,
    },
    addLink: {
      fontSize: 16,
      color: '#674FE0',
      textDecorationLine: 'underline',
      paddingVertical: 5,
    },
    imagePickerContainer: {
      alignItems: 'center',
      paddingVertical: 7,
      width: 150,
      height: 150,
    },
    imagePickerHint: {
      fontSize: 12,
      color: '#999',
      marginTop: 5,
      textAlign: 'center',
    },
    messageText: {
      color: '#674FE0',
      fontSize: 14,
      marginTop: 10,
      textAlign: 'center',
      width: '100%',
    },
    disclaimerText: {
      fontSize: 12,
      color: '#777',
      marginTop: 14,
      lineHeight: 18,
      textAlign: 'center',
    },
    checkboxRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 5,
    },
    checkboxLabel: {
      fontSize: 16,
      color: '#333',
      marginLeft: 8,
    },
    businessInputContainer: {
      width: '100%',
      marginTop: 8,
      zIndex: 1,
    },
    businessRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: 5,
    },
    // absolute so the suggestions overlay the fields below instead of being pushed off a non-scrolling screen
    placesListView: {
      position: 'absolute',
      top: 48,
      left: 0,
      right: 0,
      maxHeight: 220,
      backgroundColor: '#fff',
      borderWidth: 1,
      borderColor: '#ddd',
      borderRadius: 8,
      zIndex: 1000,
      elevation: 5,
    },
    buttonSection: {
      width: '100%',
      marginTop: 10,
    },
    textContainer: {
      paddingBottom: 15,
    },
    imageContainer: {
      paddingBottom: 20,
      height: 120,
      maxWidth: 120,
    },
    imageContainer2: {
      height: 100,
      width: 100,
    },
    headerMenuIcon: {
      paddingRight: 15,
    },
  });